<template>
    <div class="d-flex flex-column gap-1">
        <user-stores-table-edit-btn v-if="!isShopUser" :onClick="onClickEdit" />
        <div
            v-if="devices && devices.length"
            class="d-flex align-items-center cursor-pointer"
        >
            <the-btn
                @click.native="onClick"
                class="btn-primary btn-outline-custom btn-sm"
            >
                <span class="d-lg-none">Urządzenia</span>
                <a-icon
                    icon="Chevron"
                    :icon-config="{ up, down: !up }"
                />
            </the-btn>
        </div>
    </div>
</template>

<script>
import UserStoresTableEditBtn from '@/components/settings/userStores/UserStoresTableEditBtn'

export default {
    name: 'UserStoresTableActions',
    components: {
        UserStoresTableEditBtn
    },
    props: {
        onClick: {
            type: Function,
            default: () => {}
        },
        onClickEdit: {
            type: Function,
            default: () => {}
        },
        text: {
            type: String,
            default: ''
        },
        up: {
            type: Boolean,
            default: false
        },
        devices: {
            type: Array,
            required: false
        },
        isShopUser: {
            type: Boolean,
            default: false
        }
    }
}
</script>
